export default __webpack_public_path__ + "static/media/yp.7cc2a0e8.png";